<template>
  <div class="">
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入搜索内容"
        v-model.trim="text"
        class="handle-input mr10"
      ></el-input>
      <el-select size="small" v-model="type" class="mr10">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        size="small"
        type="primary"
        @click="$router.push('/operate/policy/statute_add')"
        >发布政策法规</el-button
      >
    </div>
    <el-table :data="data.records" border style="width: 100%">
      <el-table-column prop="title" label="标题" header-align="center" />
      <el-table-column
        prop="publishTime"
        label="发布时间"
        align="center"
        width="180"
      />
      <el-table-column label="阅读量" width="180" align="center">
        <template #default="scope">
          <ul>
            <li>
              {{ scope.row.reading }}
              <span class="copy" @click="handleCopyData(scope.row.id)"
                ><i class="el-icon-link"></i
              ></span>
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="240">
        <template #default="scope">
          <el-button
            type="primary"
            size="mini"
            @click="
              $router.push(`/operate/policy/statute_edit/${scope.row.id}`)
            "
            >编辑</el-button
          >
          <el-button
            type="warning"
            v-if="scope.row.status"
            size="mini"
            @click="setStatus(scope.row, 0)"
            >下架</el-button
          >
          <el-button
            type="success"
            v-else
            size="mini"
            @click="setStatus(scope.row, 1)"
            >上架</el-button
          >
          <el-button type="danger" size="mini" @click="delData(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { reactive, ref, toRefs, watch, getCurrentInstance } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import api from "./../../../api/index.js";
import NProgress from "nprogress";
export default {
  setup() {
    let text = ref("");
    let type = ref("");
    const { ctx } = getCurrentInstance();
    let options = reactive([
      { label: "全部", value: "" },
      { label: "公开", value: 1 },
      { label: "已下架", value: 0 },
    ]);
    let data = reactive({ data: { records: [] } });
    // 查询数据
    const getData = async (page = 1) => {
      if (text.value.length > 30) {
        ElMessage.warning("搜索内容最多输入30个字");
        return;
      }

      const params = {
        title: text.value,
        status: type.value,
        currentPage: page,
        pageSize: 20,
      };
      try {
        NProgress.start();
        const res = await api.policy.getData(params);
        NProgress.done();
        if (res.code === 10200) {
          data.data = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      } catch (error) {
        NProgress.done();
      }
    };
    watch([text, type], (newVal, oldVal) => {
      getData();
    });
    let loading = false;
    // 修改状态
    const setStatus = async (item, status) => {
      if (!loading) {
        const params = {
          status: status,
          id: item.id,
        };
        try {
          NProgress.start();
          loading = true;
          const res = await api.policy.setStatus(params);
          NProgress.done();
          loading = false;
          if (res.code === 10200) {
            getData(data.data.currentPage);
            ElMessage.success("操作成功！");
          } else {
            ElMessage.error(res.msg);
          }
        } catch (error) {
          NProgress.done();
          loading = false;
        }
      }
    };
    // 删除数据
    const delData = (item) => {
      ElMessageBox.confirm("你确定要删除这条数据吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          if (!loading) {
            const params = {
              id: item.id,
            };
            try {
              NProgress.start();
              loading = true;
              const res = await api.policy.delData(params);
              NProgress.done();
              loading = false;
              if (res.code === 10200) {
                getData(data.data.currentPage);
                ElMessage.success("删除成功！");
              } else {
                ElMessage.error(res.msg);
              }
            } catch (error) {
              NProgress.done();
              loading = false;
            }
          }
        })
        .catch(() => {});
    };

    const handleCopyData = (data) => {
      ctx.$copyText(`https://www.dajiaxinfu.com//policy/${data}`).then(
        (e) => {
          ElMessage.success("数据复制成功");
        },
        (e) => {
          ElMessage.error("数据复制失败");
        }
      );
    };
    getData();

    return {
      text,
      type,
      options,
      ...toRefs(data),
      setStatus,
      delData,
      getData,
      handleCopyData,
    };
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 300px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 24px;
}

.copy {
  cursor: pointer;
}
</style>